<template>
  <div>
    <div class="content-header">
      <h1>Užívatelia</h1>
    </div>
    <section class="content">
      <div class="box">
        <div class="box-header">
          <button class="btn btn-success btn-sm" @click.prevent="createShow()"><i class="fa fa-plus"></i> Pridať</button>
          <div class="box-tools">
            <div class="input-group input-group-sm input-search hidden-xs">
              <input type="text" v-model="query" class="form-control pull-right" placeholder="Vyhľadaj podľa mena.">

              <div class="input-group-btn">
                <button type="submit" class="btn btn-default"><i class="fa fa-search"></i></button>
              </div>
            </div>
          </div>
        </div>
        <password-change-modal :show-model="showChangePasswordModal" :model="selectedUser" @close="hideModals()"></password-change-modal>
        <user-modal :show-model="showCreateModal" :model="selectedUser" @close="hideModals()"></user-modal>

        <div class="box-body">
          <div class="row" v-if="users && users.length">
            <div class="col-md-12">
              <table class="table table-hover table-responsive no-paddingZ">
                <thead>
                <tr>
                  <th>Meno</th>
                  <th>Priezvisko</th>
                  <th>Prihlasovacie meno</th>
                  <th>E-mail</th>
                  <th>Telefónne číslo</th>
                  <th>Role</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="user in users">
                  <tr :class="{inactive : !user.active}">
                    <td>{{ user.firstname }}</td>
                    <td>{{ user.surname }}</td>
                    <td>{{ user.username }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.phoneNumber }}</td>
                    <td><span v-for="(role, index) in user.roles"> {{ role | codeListValue(roles) }}<span v-if="user.roles.length -1 !== index">, </span></span></td>
                    <td class="text-right text-nowrap">
                      <button class="btn btn-xs btn-link" :disabled="!editable(user.id)" @click.prevent="editUser(user)"><i class="fa fa-2x fa-pencil-square-o text-primary" title="Editovať"></i></button>
                      <button class="btn btn-xs btn-link" :disabled="!editable(user.id)" @click.prevent="changePassword(user)"><i class="fa fa-2x fa-key text-primary" title="Zmena hesla"></i></button>
                      <button class="btn btn-xs btn-link" :disabled="!activatable(user.id)" @click.prevent="toggleUserActive(user)"><i :class="{'fa-toggle-on': user.active, 'fa-toggle-off text-success': !user.active}" class="fa fa-2x" :title="user.active ? 'Deaktivovať' : 'Aktivovať'"></i></button>
                      <button class="btn btn-xs btn-link" :disabled="!deletable(user.id)" @click.prevent="deleteUser(user)"><i class="fa fa-2x fa-times text-danger" title="Zmazať"></i></button>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
          <loading id="users"></loading>
          <no-records :data="users" loadingId="users"></no-records>
        </div>
      </div>
    </section>
  </div>

</template>

<script>
  import _ from 'lodash';
  import { normalize } from 'utils';
  import {alert} from 'vue-strap';
  import {mapState} from 'vuex';
  import { roles } from 'codelist/';
  import loading from 'components/loading';
  import noRecords from 'components/noRecords';
  import userModal from 'components/userCreateModal';
  import passwordChangeModal from 'components/passwordChangeModal';
  import notificationService from 'services/notificationService';
  import userService from 'services/userService';

  export default {
    components: {alert, userModal, passwordChangeModal, loading, noRecords},
    data: () => ({
      roles: roles,
      showCreateModal: false,
      showChangePasswordModal: false,
      selectedUser: null,
      query: null
    }),
    computed: mapState({
      loading: (state) => state.app.loadingData,
      currentUser: (state) => state.auth.user,
      users(state) {
        let allUsers = state.user.items;
        if (this.query) {
          let regexp = new RegExp(normalize(this.query), "g");
          return allUsers.filter(item => !!normalize(item.fullName).match(regexp));
        } else {
          return allUsers;
        }
      }
    }),
    methods: {
      createShow () {
        this.selectedUser = userService.newUser();
        this.showCreateModal = true;
      },
      hideModals () {
        this.showCreateModal = false;
        this.showChangePasswordModal = false;
      },
      deletable (userId) {
        return this.currentUser.id !== userId;
      },
      activatable (userId) {
        return this.currentUser.id !== userId;
      },
      editable (userId) {
        return this.currentUser.id !== userId;
      },
      deleteUser (user) {
        this.confirm('user.delete.confirmation', [user.username]).then(() => {
          this.$store.dispatch('user/delete', user.id).then((result) => {
            if (result) {
              notificationService.success('user.delete.success');
            }
          }).catch(this.unprotect);
        });
      },
      toggleUserActive (user) {
        let action = user.active ? 'deactivate' : 'activate';
        this.$store.dispatch('user/' + action, user.id).then((result) => {
          if (result) {
            notificationService.success('user.' + action + '.success');
          } else {
            notificationService.error('error.user.' + action);
          }
        });
      },
      editUser (user) {
        this.selectedUser = _.cloneDeep(user);
        this.showCreateModal = true;
      },
      changePassword (user) {
        this.selectedUser = _.cloneDeep(user);
        this.showChangePasswordModal = true;
      }
    },
    created () {
      this.$store.dispatch('user/getAll')
    }
  }
</script>



// WEBPACK FOOTER //
// client/views/users.vue